import * as urlUtils from 'utils/Url';


export function getPathControlCoupons(qs={}) {
  return urlUtils.appendQueryString(`/control/coupons`, qs);
}
